import { useScrollReveal } from '../hooks/useScrollReveal';
import s from './Features.module.css';

const FEATURES = [
  { icon: '\u{1F3E2}', title: '物件管理', desc: '賃貸・売買・民泊まで、すべての物件を一元管理。写真・図面・設備情報を体系的に整理できます。' },
  { icon: '\u{1F465}', title: '顧客CRM', desc: '反響管理からマッチングまで、顧客対応を効率化。対応履歴を一目で把握できます。' },
  { icon: '\u{1F4CB}', title: '契約管理', desc: '契約書の自動生成からPDF出力まで。契約業務をデジタル化します。' },
  { icon: '\u{1F4E1}', title: 'ポータル入稿', desc: 'SUUMO・HOME\'S・at homeへの入稿データを一元管理。物件情報の整理と出稿準備を効率化します。' },
  { icon: '\u{1F4B0}', title: '家賃管理', desc: '入金消込・未収金管理を一画面で把握。督促状況の追跡も簡単に行えます。' },
];

export function Features() {
  const ref = useScrollReveal<HTMLElement>();

  return (
    <section id="features" className={`${s.section} reveal`} ref={ref}>
      <div className={s.inner}>
        <h2 className={s.title}>すべての不動産業務を、ひとつに。</h2>
        <div className={s.grid}>
          {FEATURES.map((f, i) => (
            <div key={i} className={s.card}>
              <span className={s.icon}>{f.icon}</span>
              <h3 className={s.cardTitle}>{f.title}</h3>
              <p className={s.cardDesc}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
